import { downloadCSV, Record } from 'react-admin'
import jsonExport from 'jsonexport/dist'

export const csvExporter = (items: any[], exporter: (items: Record[]) => any[], filename: string) => {
  return jsonExport(exporter(items), (err: any, csv: Record[]) => downloadCSV(csv, filename))
}
